require('./brokerPensionPlanHeader.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { ContentBox } = require('commonsComponents/contentBox');
const StockExchangeIndexVariation = require('components/broker/commons/stockExchange/stockExchangeIndexVariation.js');
// @ helpers
const { LabelDate } = require('commonsComponents/labelDate');
const { formatAmount, formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');
// @ constants
const { BROKER_PENSION_PRICE_DECIMALS } = require('constants/index');
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');

class BrokerPensionPlanHeader extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const { immBrokerProductAdvancedSearch } = this.props;
        const immPensionPlan = this.props.immPensionPlan.get('pensionPlan');
        const name = immPensionPlan.get('name');
        const dgscode = immPensionPlan.get('dgscode');
        const performanceYTD = `${immPensionPlan.get('returnM0')} %`;
        const netAssetDayEndValue = immPensionPlan.get('netAssetValue').set('decimalsLength', BROKER_PENSION_PRICE_DECIMALS);
        const variationPoints = immPensionPlan.get('variationPoints').toString();
        const variationPercent = immPensionPlan.get('variationPercent').toString();
        const netAssetDayEndDate = immPensionPlan.getIn(['netAssetValue', 'dayEndDate']);
        const plainAmountObject = getPlainAmountObject(netAssetDayEndValue);
        const currencySymbol = formatAmountObject(plainAmountObject, true).currencySymbol;
        const language = getLanguage();

        const performanceYTDLabel = `${formatText('brokerHireInvestment-performanceYTD')}: `;
        const performanceLastYearLabel = `${formatText('brokerHireInvestment-lastYearProfitability')} ${DateHelper.getFullYear(DateHelper.todayDate()) - 1}: `;
        const immInstrumentList = immBrokerProductAdvancedSearch.getIn(['results','plans','instrumentsList']);
        let performanceLastYear;
        if (immInstrumentList) {
            const performanceLastYearValue = immInstrumentList.getIn([ 0, 'lastYearReturnValue']);
            performanceLastYear = performanceLastYearValue ?
            formatAmount(Number(performanceLastYearValue).toFixed(2)) + " %" :
            '-';
        }
        else {
            performanceLastYear = '-';
        }

        return (
            <ContentBox
                id="brokerStocksLikeHeader"
                customClassName="broker-hire-investment-header broker-hire-investment-header--pension-plan"
            >
                <div className="broker-pension-plan-header__header row">
                    <div className="col-lg-8">
                        <div className="broker-hire-investment-header__company-header">
                            <h2 className="broker-hire-investment-header__company-name">
                                {name}
                            </h2>
                        </div>
                        <span className="broker-pension-plan-header__isin">
                            <FormattedText value={"brokerHireInvestment-dgsCode"} />: {dgscode}
                        </span>
                    </div>
                    <div className="col-lg-4">
                        <div className="broker-hire-investment-header__quote-box">
                            <div className="broker-hire-investment-header__quote">
                                {performanceYTDLabel}
                                <span className="broker-hire-investment-header__product-value">
                                    {performanceYTD}
                                </span>
                            </div>
                            <div className="broker-hire-investment-header__quote-last-year">
                                {performanceLastYearLabel}
                                <span className="broker-hire-investment-header__product-value-last-year">
                                    {performanceLastYear}
                                </span>
                            </div>
                            <span className="broker-pension-plan-header__quote">
                                <FormattedText value={"brokerHireInvestment-netAssetDayEndDate"} />
                                {" "}
                                <OneLineSymbolAmount
                                    amountObject={plainAmountObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                                />
                            </span>
                            <div className="broker-hire-investment-header__product-value-container">
                                <div className="broker-pension-plan-header__index-box">
                                    <span className="broker-hire-investment-header__index-value">
                                        <StockExchangeIndexVariation
                                            variationPts={formatAmount(variationPoints, undefined, BROKER_PENSION_PRICE_DECIMALS)}
                                            variationPerc={formatAmount(variationPercent)}
                                            currencySymbol={currencySymbol}
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="broker-pension-plan-header__last-price-date">
                            <span className="broker-pension-plan-header__last-price-date">
                                (<LabelDate
                                    date={netAssetDayEndDate}
                                    language={language}
                                    today={LABEL_DATE_TODAY}
                                    yesterday={LABEL_DATE_YESTERDAY}
                                />)
                            </span>
                        </div>
                    </div>
                </div>
            </ContentBox>
        );
    }
}

BrokerPensionPlanHeader.propTypes = {
    immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
    immPensionPlan: PropTypes.object.isRequired
};

module.exports = BrokerPensionPlanHeader;
